module.exports = __webpack_public_path__ + "static/img/content0.35e51ec2.png";